export const COMPANY = {
  name: "NDNS Elektro",
  tagline: "Instalacje elektryczne i sieci słaboprądowe",
  city: "Katowice",
  phone: "+48 794 000 454",
  phoneHref: "tel:+48794000454",
  email: "ndnselektro@gmail.com",
  areas: ["Katowice", "Górny Śląsk", "Województwo Śląskie", "Małopolska"],
  address: "ul. Ligocka 80",
  postal: "40-569 Katowice",
  legalName: "NDNS Sp. z o.o.",
  nip: "634 30 20 318",
  logo: "/ndns-logo.png",
  logoWhite: "/ndns-logo-white.png",
};

export const SERVICES = [
  {
    id: "instalacje-elektryczne",
    icon: "Zap",
    title: "Instalacje elektryczne i wykonawstwo",
    seo: "Instalacje elektryczne Katowice",
    desc: "Projektujemy i wykonujemy od podstaw instalacje elektryczne w domach jednorodzinnych, mieszkaniach oraz halach i magazynach przemysłowych. Modernizujemy stare sieci pod współczesne obciążenia.",
    points: ["Domy i mieszkania", "Hale i obiekty przemysłowe", "Modernizacja instalacji"],
    image:
      "https://images.unsplash.com/photo-1758101755915-462eddc23f57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwZWxlY3RyaWNhbCUyMGluc3RhbGxhdGlvbiUyMHBhbmVsJTIwd2lyaW5nfGVufDB8fHx8MTc4MzMyOTU0Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "systemy-bezpieczenstwa",
    icon: "ShieldCheck",
    title: "Systemy bezpieczeństwa – alarmy i CCTV",
    seo: "Monitoring CCTV i alarmy SSWiN",
    desc: "Nowoczesne systemy alarmowe SSWiN oraz monitoring CCTV. Integracja kamer i czujników daje stały podgląd na obiekt z poziomu smartfona, z dowolnego miejsca na świecie.",
    points: ["Systemy alarmowe SSWiN", "Monitoring CCTV / telewizja przemysłowa", "Podgląd na smartfonie"],
    image:
      "https://images.unsplash.com/photo-1585206031650-9e9a7c87dcfe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxzZWN1cml0eSUyMGNhbWVyYSUyMGJ1aWxkaW5nJTIwbW9kZXJufGVufDB8fHx8MTc4MzMyOTQ3NHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "sieci-slabopradowe",
    icon: "Network",
    title: "Sieci słaboprądowe i systemy PPOŻ",
    seo: "Sieci słaboprądowe i PPOŻ",
    desc: "Kompleksowe projektowanie i wykonawstwo sieci słaboprądowych: systemy przeciwpożarowe PPOŻ i SSP, okablowanie strukturalne LAN, instalacje domofonowe, wideodomofonowe i telewizyjne.",
    points: ["Systemy PPOŻ / SSP", "Okablowanie strukturalne LAN", "Domofony i wideodomofony"],
    image:
      "https://images.unsplash.com/photo-1683322499436-f4383dd59f5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxuZXR3b3JrJTIwY2FibGluZyUyMHNlcnZlciUyMHJhY2slMjBzdHJ1Y3R1cmVkfGVufDB8fHx8MTc4MzMyOTU0Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "smart-home",
    icon: "Cpu",
    title: "Inteligentny Dom – Smart Home",
    seo: "Smart Home i automatyka budynkowa",
    desc: "Nowoczesne instalacje Smart Home z automatycznym sterowaniem oświetleniem, ogrzewaniem, roletami i systemem bezpieczeństwa. Rozwiązania dopasowane do Twoich potrzeb i budżetu.",
    points: ["Automatyka oświetlenia", "Sterowanie ogrzewaniem i roletami", "Integracja z bezpieczeństwem"],
    image:
      "https://images.unsplash.com/photo-1747224317387-ee2e7eaa865d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxzbWFydCUyMGhvbWUlMjB3YWxsJTIwdGFibGV0fGVufDB8fHx8MTc4MzMyOTQ3NHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "pomiary-elektryczne",
    icon: "Gauge",
    title: "Pomiary elektryczne i odbiory",
    seo: "Pomiary elektryczne SEP",
    desc: "Pomiary powykonawcze niezbędne do odbioru budynku oraz okresowe pomiary pięcioletnie. Badamy oporność izolacji, skuteczność zerowania i wyłączniki RCD. Wystawiamy pełne protokoły dla nadzoru i ubezpieczycieli.",
    points: ["Pomiary powykonawcze i odbiorowe", "Okresowe pomiary 5-letnie", "Protokoły dla nadzoru budowlanego"],
    image:
      "https://static.prod-images.emergentagent.com/jobs/84cb96e8-d8b9-48e9-a45f-1065ec73a096/images/d1428eacd2fb0078baa4f3e768b7f05e7685662186aea6607802ed7736ba3b0d.png",
  },
];

export const REASONS = [
  {
    icon: "Award",
    title: "Uprawnienia SEP i certyfikaty",
    desc: "Pełne uprawnienia eksploatacyjne i dozorowe SEP oraz certyfikaty instalatorskie nowoczesnych systemów zabezpieczeń.",
  },
  {
    icon: "MapPin",
    title: "Lokalny profesjonalizm",
    desc: "Firma z Katowic – gwarantujemy szybki dojazd do klientów na terenie Śląska i Małopolski.",
  },
  {
    icon: "Network",
    title: "Sieci słaboprądowe na najwyższym poziomie",
    desc: "Wiedza i sprzęt do realizacji klasycznych instalacji elektrycznych oraz nowoczesnych sieci IT, teletechnicznych i bezpieczeństwa.",
  },
  {
    icon: "CheckCircle2",
    title: "Indywidualne podejście",
    desc: "Od podłączenia płyty indukcyjnej po instalację PPOŻ w hali przemysłowej – zawsze najwyższa jakość obsługi.",
  },
];

export const GALLERY = [
  "https://images.unsplash.com/photo-1722152249188-12b449bc0232?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxjbGVhbiUyMG1vZGVybiUyMGVsZWN0cmljYWwlMjBkaXN0cmlidXRpb24lMjBib2FyZCUyMGJyZWFrZXJzfGVufDB8fHx8MTc4MzMzNTczMnww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1544724569-5f546fd6f2b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxuZWF0JTIwb3JnYW5pemVkJTIwZWxlY3RyaWNhbCUyMHdpcmluZyUyMGluc3RhbGxhdGlvbnxlbnwwfHx8fDE3ODMzMzU3MzJ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1683322499436-f4383dd59f5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxuZXR3b3JrJTIwY2FibGluZyUyMHNlcnZlciUyMHJhY2slMjBzdHJ1Y3R1cmVkfGVufDB8fHx8MTc4MzMyOTU0Nnww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1585206031650-9e9a7c87dcfe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxzZWN1cml0eSUyMGNhbWVyYSUyMGJ1aWxkaW5nJTIwbW9kZXJufGVufDB8fHx8MTc4MzMyOTQ3NHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1758101755915-462eddc23f57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwZWxlY3RyaWNhbCUyMGluc3RhbGxhdGlvbiUyMHBhbmVsJTIwd2lyaW5nfGVufDB8fHx8MTc4MzMyOTU0Nnww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1747224317387-ee2e7eaa865d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxzbWFydCUyMGhvbWUlMjB3YWxsJTIwdGFibGV0fGVufDB8fHx8MTc4MzMyOTQ3NHww&ixlib=rb-4.1.0&q=85",
];
